// @mui material components
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Icon from "@mui/material/Icon";
import { keyframes } from "@mui/system";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Custom styles for the SidenavCard
import { card, cardContent, cardIconBox, cardIcon } from "examples/Sidenav/styles/sidenavCard";

// Soft UI Dashboard PRO React context
import { useSoftUIController } from "context";

function SidenavCard() {
  const [controller] = useSoftUIController();
  const { miniSidenav, sidenavColor } = controller;

  // Define subtle pulse animation
  const pulseAnimation = keyframes`
    0% { transform: scale(1); }
    50% { transform: scale(1.05); }
    100% { transform: scale(1); }
  `;

  return (
    <Card sx={(theme) => card(theme, { miniSidenav })}>
      <CardContent
        sx={(theme) => ({
          ...cardContent(theme, { sidenavColor }),
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          ...(miniSidenav && {
            padding: 0,
            "&:last-child": { padding: 0 },
          }),
        })}
      >
        <SoftBox
          bgColor="white"
          width="3rem"
          height="3rem"
          borderRadius="md"
          shadow="md"
          mb={miniSidenav ? 0 : 2}
          mx="auto"
          sx={{
            ...cardIconBox,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            animation: `${pulseAnimation} 2s infinite ease-in-out`
          }}
        >
          <Icon fontSize="medium" sx={(theme) => cardIcon(theme, { sidenavColor })}>
            visibility
          </Icon>
        </SoftBox>
        <SoftBox lineHeight={1} textAlign="center" sx={{ display: miniSidenav ? "none" : "block" }}>
          <SoftTypography variant="h6" color="white" fontWeight="bold">
            Sistem de Raportare
          </SoftTypography>
          <SoftBox mb={1.5} mt={0.5} px={2}>
            <SoftTypography 
              variant="caption" 
              color="white" 
              fontWeight="medium"
              sx={{ 
                display: "block",
                fontSize: "0.6rem",
                lineHeight: 1.2,
                wordBreak: "break-word",
                whiteSpace: "normal",
                hyphens: "auto"
              }}
            >
              Stop Rasism - sistem integrat pentru raportarea incidentelor antisemite, rasiste și xenofobe
            </SoftTypography>
          </SoftBox>
        </SoftBox>
      </CardContent>
    </Card>
  );
}

export default SidenavCard;
